import i18n from "src/i18n/i18n";
import * as Yup from "yup";

export default class Role {
    id: number;
    name: string;
    description: string;
    created_at: string;
    updated_at: string;
    permissions: any[];

    static getRules() {
        return Yup.object().shape({
            name: Yup.string()
                .max(191)
                .required(i18n.t("VALIDATION.REQUIRED")),
            description: Yup.string()
                .max(191)
                .required(i18n.t("VALIDATION.REQUIRED")),
            permissions: Yup.array().test({
                name: "categories_test",
                exclusive: true,
                message: i18n.t('VALIDATION.MIN_ONE'),
                test: (value) => value.length > 0,
            })
        })
    }

    static getInitValues(role: Role) {
        return {
            name: role ? role.name : "",
            description: role ? role.description : "",
            permissions: role ? role.permissions.map(permission => permission.id + "") : [],
        }
    }
}
